import { api } from "@/frontend/services/api";
import type { ApiResponse } from "@/shared/dto";

export interface PoolComment {
  id: string;
  poolId: string;
  userId: string;
  parentId: string | null;
  author: string;
  text: string;
  createdAt: string;
  updatedAt: string;
  likes: number;
  dislikes: number;
  userReaction: "like" | "dislike" | null;
  replies: PoolComment[];
}

export interface CreatePoolCommentRequest {
  text: string;
  parentId?: string | null;
}

export interface SetPoolCommentReactionRequest {
  reaction: "like" | "dislike" | null;
}

const BASE_URL = "/betting-pools/private";

export const poolCommentService = {
  getByPool: (poolId: string) =>
    api.get<ApiResponse<PoolComment[]>>(`${BASE_URL}/${poolId}/comments`),
  create: (poolId: string, data: CreatePoolCommentRequest) =>
    api.post<ApiResponse<PoolComment>>(`${BASE_URL}/${poolId}/comments`, data),
  setReaction: (poolId: string, commentId: string, data: SetPoolCommentReactionRequest) =>
    api.patch<ApiResponse<void>>(`${BASE_URL}/${poolId}/comments/${commentId}/reaction`, data),
};
